import React from "react";
import { TableOp } from "../../../components/table/TableOps.tsx";
import TableComponent from "../../../components/table/TableOps";
import Autocomplete from "@material-ui/lab/Autocomplete";
import { TextField, Button, Slide, Snackbar, DialogTitle, DialogActions, Dialog, CircularProgress } from "@material-ui/core";
import Http from "../../../Http";
import { isDate } from "../../../helpers/isDate";
import moment from 'moment';
import ACCESS from "../../../ACCESS.js";

export default class EnvioFacturasDetalles extends TableComponent {
  componentDidMount() {
    let { id, currentEnvio } = this.props;
    let acciones = [
      { id: "show", icon: "visibility", access: [ACCESS.COBRANZA_ENVIO_FACTURAS.CREAR_FOLIO] },
      { id: "delete", icon: "delete", access: [ACCESS.COBRANZA_ENVIO_FACTURAS.CREAR_FOLIO] },
    ];
    if (currentEnvio && (currentEnvio.status === 2 || currentEnvio.status === 3)) {
      acciones = [{ id: "show", icon: "visibility", access: [ACCESS.COBRANZA_ENVIO_FACTURAS.CREAR_FOLIO]  }];
    }
    this.tableConfig(
      {
        dataUrl: id ? `facturacion/guiasbyfactura?factura_id=${id}` : false,
        deleteUrl: false,
        deleteField: false,
        modUrl: false,
      },
      TableOp.Table(
        "Guias",
        [
          { label: "Linea", id: "linea" },
          { label: "Guia", id: "g_folio" },
          { label: "Fecha Documentada", id: "g_fecha" },
        ],
        acciones
      )
    );
    /* if (this.props.id) {
      this.LoadPreds()
    } */
    this.table();
    this.setState({ loading: false, deletedGuias: [], mode: 'typing' });
    this.scannedFolio = "";
    this.myRef = React.createRef();
  }

  keyDown = (e) => {
    if (e.keyCode === 13 && this.scannedFolio.length > 0) {
      this.valueFolioSearchChange(null, this.scannedFolio);
      this.scannedFolio = "";
    } else {
      if (!isNaN(e.key)) {
        this.scannedFolio = `${this.scannedFolio}${e.key}`;
      }
    }
  };

  valueFolioSearchChange = async (value, id_guia) => {
    if ((value && value  !== '' && value.length > 2 ) || id_guia) {
      let strQuery = ``;
      if (!id_guia) {
        strQuery = `folio=${value}`
      } else {
        strQuery = `id_guia=${id_guia}`
      }
      this.setState({ inputValue: value });
      const Res = await Http.get(`facturacion/search?${strQuery}`);
      if (!Res.error) {
        this.setState({ searchOptions: Res.data });
        if(id_guia && Res.data && Res.data.length > 0) {
          this.onSelectFolio(Res.data[0]);
          this.onChangeFolio()
        }

      }
    } else {
      this.setState({ inputValue: value });
    }
  };

  onSelectFolio = (val) => {
    this.setState({ currentGuia: val, inputValue: val.g_folio });
  };

  onChangeFolio = () => {
    const { tableData, currentGuia } = this.state;
    if (!currentGuia) {
      return;
    }
    const exist = tableData.rows.some((row) => row.id === currentGuia.id);
    if (!exist) {
      for (let prop in currentGuia) {
        if (prop !== 'id' && prop !== 'id_unidad_transporte' && isDate(currentGuia[prop])) {
          currentGuia[prop] = moment(currentGuia[prop]).format('D/M/YYYY HH:mm');
        }
      }
      tableData.rows = [currentGuia, ...tableData.rows];
      this.props.showGuia(currentGuia.id);
      this.setState({
        tableData: {
          ...tableData,
          rows: tableData.rows,
          total: tableData.rows.length,
        },
        currentGuia,
        inputValue: "",
      });
    }
  };

  sendFacturas = async (type) => {
    this.setState({ saveloading: true });
    const { tableData, deletedGuias } = this.state;
    if (tableData.rows.length <= 0) {
      this.setState({ sbOpen: true, sbMsg: "Porfavor Agregar Guías" });
      return;
    }
    const Res = await Http.post("facturacion/save", {
      guias: tableData.rows,
      deletedGuias,
      type,
      id: this.props.id,
    });
    if (!Res.error) {
      this.setState({ folioOpen: true, folio: Res.data.id });
    } else {
      this.setState({ sbOpen: true, sbMsg: Res.errMsg });
    }
    this.setState({ saveloading: false });
  };

  action = (id, row) => {
    if (id === "show") {
      this.props.showGuia(row.id);
    } else if (id === "delete") {
      const { tableData, deletedGuias = [] } = this.state;
      const rows = tableData.rows.filter((fil) => fil.id !== row.id);
      deletedGuias.push(row);
      this.setState({
        deletedGuias,
        tableData: { ...tableData, rows: rows, total: rows.length },
      });
    }
  };

  onCloseModal = () => {
    this.props.history.goBack();
  }

  changeMode =  () => {
    const { mode } = this.state;
    if (mode !== "scanning") {
      window.addEventListener("keydown", this.keyDown);
    } else {
      window.removeEventListener("keydown", this.keyDown);
    }
    this.setState({ mode:  mode === 'typing' ? 'scanning' : 'typing' })
    this.myRef.current.blur();
  }

  render() {
    let { searchOptions, sbMsg, sbOpen, inputValue = "", folioOpen, folio, saveloading = false, mode = 'typing' } = this.state;
    let { currentEnvio } = this.props;
    searchOptions = searchOptions || [];
    return (
      <div>
        {(!currentEnvio || currentEnvio.status === 1) && (
          <div
            style={{
              display: "flex",
              flexFlow: "column wrap",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <h1>Añadir Guias</h1>
            <Button ref={this.myRef}  variant="text" color="primary" onClick={this.changeMode}>
              Cambiar a modo
              {mode === "typing" ? " Scaneo Codigo de Barras" : " Busqueda Manual"}
            </Button>
            { mode === 'typing' ? 
              <div style={{
                display: "flex",
                flexFlow: "row wrap",
                justifyContent: "center",
                alignItems: "center",  
                }} 
              >
                  <Autocomplete
                    options={searchOptions}
                    disableClearable
                    getOptionLabel={(option) => option.g_folio}
                    onChange={(e, val) => {
                      this.onSelectFolio(val);
                    }}
                    inputValue={inputValue}
                    renderInput={(params) => (
                      <TextField
                        style={{ minWidth: "200px" }}
                        {...params}
                        label="Buscar Guias"
                        variant="outlined"
                        onChange={(e) => {
                          this.valueFolioSearchChange(e.target.value);
                        }}
                        margin="normal"
                      />
                    )}
                  />
                  <Button
                    color="primary"
                    variant="contained"
                    onClick={this.onChangeFolio}
                    style={{ margin: 10 }}
                  >
                    Agregar guia
                  </Button>
              </div>
              : 
              <div>
                <div> {inputValue ? `Folio: ${inputValue}` : "Esperando Lectura"} </div>
              </div>
            }
            <div
              style={{
                display: "flex",
                flexFlow: "row wrap",
                justifyContent: "flex-end",
                alignItems: "center",
                width: '100%'
              }}
            >
              <Button
                disabled={saveloading}
                onClick={() => this.sendFacturas(1)}
                color="primary"
                variant="contained"
                style={{ margin: 10 }}
              >
              
                <div style={{ marginRight: 10, padding: 0, height: 22 }} hidden={!saveloading}>
                  <CircularProgress color="secondary" size={20} />
                </div>
                Guardar
              </Button>
              <Button
                disabled={saveloading}
                onClick={() => this.sendFacturas(2)}
                color="primary"
                variant="contained"
              >
                <div style={{ marginRight: 10, padding: 0, height: 22 }} hidden={!saveloading}>
                  <CircularProgress color="secondary" size={20} />
                </div>
                Guardar y Enviar
              </Button>
            </div>
          </div>
        )}
        <div>
          <this.TableRender />
          <Snackbar
            resumeHideDuration={2000}
            autoHideDuration={2000}
            open={sbOpen === undefined ? false : sbOpen}
            onClose={() => {
              this.setState({ sbOpen: false });
            }}
            TransitionComponent={Slide}
            message={<span>{sbMsg}</span>}
          />

          {/* Modal Folio  */}
          <Dialog onClose={this.onCloseModal} open={folioOpen ? folioOpen : false}>
            <DialogTitle onClose={() => { this.setState({ folioOpen: false }) }}>
              Folio: <span style={{fontWeight: 'bolder'}}>{folio}</span>
            </DialogTitle>
            <DialogActions>
              <Button autoFocus onClick={this.onCloseModal} color="primary">
                Aceptar
              </Button>
            </DialogActions>
          </Dialog>
        </div>
      </div>
    );
  }
}
